import { buildQuestionHash } from '@omnea-app/fe-routing/links/questionHash'
import { buildBlockAddress, buildConditionGroupAddress, type BlockAddress } from '@omnea-app/fe-routing/links/workflowAddress'
import { hrefFor, hrefWith } from '../routeHref'

/** Where the editor opens: a place in a block, or a condition group in the tags dialog. */
type WorkflowEditorFocus = BlockAddress | { conditionGroupId: string }

type FormEditorLink = { formTemplateId: string; itemId?: string }

type WorkflowEditorLink = { workflowId: string; draftId?: string; focus?: WorkflowEditorFocus }

const fragmentOf = (focus: WorkflowEditorFocus) =>
  'conditionGroupId' in focus ? buildConditionGroupAddress(focus.conditionGroupId) : buildBlockAddress(focus)

export const settingsPaths = {
  forms: {
    list: (): string => hrefFor('settingsForms'),
    // The forms page reads the form from the part of the settings catch-all after its own, which the registry has no param for.
    editor: ({ formTemplateId, itemId }: FormEditorLink): string => {
      const path = `${hrefFor('settingsForms')}/${encodeURIComponent(formTemplateId)}`
      return itemId ? `${path}${buildQuestionHash(itemId)}` : path
    },
  },
  workflows: {
    list: (): string => hrefFor('settingsWorkflows'),
    editor: ({ workflowId, draftId, focus }: WorkflowEditorLink): string => {
      const path = draftId
        ? hrefWith('settingsWorkflowDraftEdit', { id: workflowId, draftId })
        : hrefWith('settingsWorkflowEdit', { id: workflowId })
      return focus ? `${path}#${fragmentOf(focus)}` : path
    },
  },
}
